import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCommits: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="commits"><circle cx="12" cy="12" r="5.25" stroke="currentColor" strokeWidth="1.5"/><path d="M6.5 12H1.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M22.25 12H17.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconCommits;
